import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, CalendarDays } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useI18n } from "../../lib/i18n";

export function HeaderBar() {
  const { user, can } = useAuth();
  const { lang } = useI18n();
  const [alerts, setAlerts] = useState(null);
  const [today, setToday] = useState([]);
  useEffect(() => {
    if (can("alerts:read")) api.get("/alerts").then((r) => setAlerts({ total: r.data.length, critical: r.data.filter((a) => a.severity === "critical").length })).catch(() => {});
    if (can("academics:read")) api.get("/planning/rombel-today").then((r) => setToday(r.data.filter((x) => x.status === "active" || x.status === "off"))).catch(() => {});
  }, []); // eslint-disable-line
  const locale = { id: "id-ID", en: "en-US", jp: "ja-JP" }[lang];
  const dateStr = new Date().toLocaleDateString(locale, { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  return (
    <div className="flex items-center gap-2 sm:gap-4 min-w-0" data-testid="header-bar">
      <span className="hidden md:inline-flex items-center gap-1.5 text-xs text-slate-500" data-testid="header-date"><CalendarDays className="h-3.5 w-3.5" />{dateStr}</span>
      {today.length > 0 && <div className="hidden lg:flex items-center gap-1 overflow-x-auto max-w-[520px]" data-testid="header-rombel-days">
        {today.slice(0, 6).map((r) => <Link key={r.group_id} to="/assessment" title={`${r.name}: Hari ke-${r.day} dari ${r.total}`} className="chip chip-active shrink-0 hover:bg-sky-100 transition-colors"><b>{r.name}</b><span className="opacity-80">H-{r.day}/{r.total}</span></Link>)}
        {today.length > 6 && <span className="text-[11px] text-slate-400">+{today.length - 6}</span>}
      </div>}
      {alerts && <Link to="/alerts" data-testid="header-alert-bell" title={`${alerts.total} alert aktif · ${alerts.critical} kritis`} className="relative grid h-9 w-9 place-items-center rounded-full border border-slate-200 bg-white text-slate-600 hover:border-sky-400 hover:text-[color:var(--brand-blue)] transition-colors">
        <Bell className="h-4 w-4" />
        {alerts.total > 0 && <span className={`absolute -top-1 -right-1 min-w-[18px] h-[18px] rounded-full px-1 text-[10px] font-bold text-white grid place-items-center ${alerts.critical ? "bg-red-600" : "bg-orange-500"}`}>{alerts.total > 99 ? "99+" : alerts.total}</span>}
      </Link>}
      <span className="hidden sm:grid h-9 w-9 place-items-center rounded-full bg-[color:var(--brand-blue)] text-white text-sm font-bold font-heading" title={user.name}>{user.name?.[0]}</span>
    </div>
  );
}
